/**
 * Used to determine whether to show /popular page
 * @deprecated Use SHOULD_SHOW_POPULAR_PAGE_V2 instead
 */ export var SHOULD_SHOW_POPULAR_PAGE = 'SHOULD_SHOW_POPULAR_PAGE';
